import { Link } from "react-router-dom";

const STATS = [
  { value: "20000+", label: "影视资源" },
  { value: "1080P", label: "高清画质" },
  { value: "7×24", label: "资讯更新" },
  { value: "免费", label: "在线观看" },
];

export default function SiteIntro() {
  return (
    <section className="rounded-lg bg-background-900 border border-background-800 overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        <div className="p-6 md:p-10 flex flex-col justify-center">
          <span className="inline-flex items-center gap-2 text-primary-400 text-sm font-medium mb-4">
            <i className="ri-water-flash-line"></i>
            关于西瓜影音
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-4 leading-tight">
            一个为影视爱好者打造的<br className="hidden md:block" />
            高清观影与资讯聚合平台
          </h2>
          <p className="text-sm md:text-base text-foreground-300 leading-relaxed mb-4">
            西瓜影音致力于用清爽的界面和高效的查找方式，帮你在海量影视内容里快速找到想看的作品。无论是院线新片、口碑剧集，还是圈内资讯与深度影评，都能在这里一览无余。
          </p>
          <p className="text-sm text-foreground-400 leading-relaxed mb-6">
            我们相信，好的观影体验不只在于内容本身，也在于发现它的过程是否足够轻松愉悦。
          </p>
          <div className="flex flex-wrap items-center gap-3">
            <Link
              to="/about"
              className="px-5 py-2.5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors"
            >
              了解更多
            </Link>
            <Link
              to="/news"
              className="px-5 py-2.5 rounded-md bg-background-800 hover:bg-background-700 text-foreground-100 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors"
            >
              浏览资讯
            </Link>
          </div>
        </div>

        <div className="relative min-h-[240px] lg:min-h-full bg-background-800">
          <img
            src="https://readdy.ai/api/search-image?query=Cinematic%20stylized%20artistic%20collage%20of%20film%20reels%20and%20cinema%20theme%20with%20warm%20orange%20light%20deep%20dark%20toned%20background%20atmospheric%20glow%20high%20detail%20editorial%20composition%20with%20dark%20space&width=900&height=700&seq=wm-intro-brand&orientation=landscape"
            alt="西瓜影音品牌介绍配图"
            title="西瓜影音 高清影视平台"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background-950/70 to-transparent lg:bg-gradient-to-r lg:from-background-900 lg:to-transparent"></div>
          <div className="relative z-10 grid grid-cols-2 gap-3 p-6 md:p-8 h-full content-end">
            {STATS.map((stat) => (
              <div key={stat.label} className="rounded-lg bg-background-950/70 border border-background-800 px-4 py-3 backdrop-blur">
                <p className="font-heading text-xl md:text-2xl font-bold text-accent-400">{stat.value}</p>
                <p className="text-xs text-foreground-300 mt-1">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}